const BooleanEnum = Object.freeze({
  'true': 'Sim',
  'false': 'Não',
  'S': 'Sim',
  'N': 'Não',
})

export default BooleanEnum;